// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { DeleteButtonProps, DeleteButton as RaDeleteButton } from 'react-admin';

import { PermissionActionT } from '@Common/types/bo/authorization';
import { BOResourceAll } from '@Common/types/bo_external/resources';

import { useCanAccess } from '@sh4res/bo-common/hooks';

export interface DeleteButtonPropsI extends DeleteButtonProps {
  testId?: string;
  ['data-testid']?: never;
  readonly permissions: {
    readonly resource: BOResourceAll;
    readonly action: PermissionActionT;
  };
}

export function DeleteButton({
  permissions: { resource, action },
  testId,
  ...props
}: DeleteButtonPropsI) {
  const canAccess = useCanAccess({
    resource,
    action,
  });

  if (canAccess) {
    return <RaDeleteButton {...props} data-testid={testId} disableElevation={true} />;
  }

  return null;
}
